<script>
export default {
  model: {
    prop: 'appDialogShow',
    event: 'updateAppDialogShow'
  },
  props: {
    appDialogShow: {
        default:false,
        type:Boolean
    },
  },
  computed: {
    $_show: {
      get () {
        return this.appDialogShow
      },
      set (value) {
        this.$emit('updateAppDialogShow', value)
      }
    }
  },
  methods: {
    $_beforeShow () {},
    $_beforeHide () {},

    show (...rest) {
      this.$_beforeShow(...rest)
      this.$_show = true
    },

    hide (...rest) {
      this.$_beforeHide(...rest)
      this.$_show = false
    }
  },
  // watch: {
  //   appDialogShow (value) {
  //     value ? this.$_showed() : this.$_hided()
  //   }
  // }
}
</script>
